"use strict";
var EscapeStack = (function () {
    function EscapeStack() {
        this._stack = [];
    }
    /**
     * Pushes an event handler onto the stack
     * Returns a function that when called removes that particular handler
     * from the stack without executing its callback
     *
     * @param {Function} handler
     */
    EscapeStack.prototype.add = function (handler) {
        var _this = this;
        this._stack.push(handler);
        return function () { return _this._removeEscapeHandler(handler); };
    };
    /**
     * Removes the given handler from the stack without executing its callback
     * This should never be called explicitly, it is the function returned by add()
     *
     * @param {Function} handler - the reference to the handler function to remove
     */
    EscapeStack.prototype._removeEscapeHandler = function (handler) {
        var index = this._stack.indexOf(handler);
        if (index !== -1) {
            this._stack.splice(index, 1);
        }
    };
    /**
     * Removes event handlers from the top of the stack and executes their callbacks.
     * Continues to remove handlers until `true` is returned by a callback or the stack is empty
     *
     * @param {Event} event
     */
    EscapeStack.prototype.pop = function (event) {
        while (this._stack.length > 0 && !(this._stack.pop())(event)) { }
    };
    return EscapeStack;
}());
exports.EscapeStack = EscapeStack;
//# sourceMappingURL=EscapeStack.js.map